import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

import { renderInstructorPage } from './-route-wrappers';

const StudentProfile = lazyRouteComponent(() => import('@/_instructor/customer-profile'));

export const Route = createFileRoute('/_instructor/student/$id')({
  component: () => renderInstructorPage(StudentProfile),
});
